import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Box, Button } from '@mui/material';
import { ReactComponent as NoDataImage } from '../../assets/NoDataImage.svg';

const NotFound404 = () => {
  const navigate = useNavigate();
  const subadmin = useSelector((state) => state.common.subAdminBoolean);
  const theme = useTheme();

  return (
    <Box mt={20}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          direction="column"
          style={{ height: 'calc(100vh - 200px)' }}
        >
          <Grid container justifyContent="center" alignItems="center">
            <NoDataImage style={{ color: theme.palette.primary.main }} />
          </Grid>
          <Grid item>
            <Typography
              variant="h4"
              color="textSecondary"
              align="center"
              style={{ color: '#141A3F', fontSize: '18px', lineHeight: '25px' }}
            >
              Sorry, we couldn’t find the page you are looking for.
            </Typography>
          </Grid>
          <Grid item>
            <Button
              onClick={() =>
                navigate(subadmin ? '/application-setting' : '/dashboard')
              }
              variant="contained"
              color="primary"
            >
              GO BACK TO HOME
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default NotFound404;
